import type { FeatureFlags } from '@cobliteam/hooks/src/useFeatureFlags';
import type { Permission } from '@cobliteam/permissions';
import type { RouteDef, RuntimeFlags, SidebarDef } from '../../../dashboardDef.type';
import getPagesFlatted from './getPagesFlatted';
import getRouter from './getRouter';
import getRoutesWithEnvironment from './getRoutesWithEnvironment';
import getRoutesWithFeatureFlag from './getRoutesWithFeatureFlag';
import getRoutesWithPermission from './getRoutesWithPermission';
import getRoutesWithRedirect from './getRoutesWithRedirect';
import getRoutesWithRuntimeFlag from './getRoutesWithRuntimeFlag';

interface GetSidebarProps {
  dashboardDef: RouteDef[];
  runtimeFlags: RuntimeFlags;
  featureFlags: FeatureFlags;
  isAccessAllowed: (permission: Permission | Permission[]) => boolean;
  language?: string;
  /** Recebido do chamador, e não lido de `window.location`, para o resultado depender só dos argumentos. */
  currentPath: string;
}

const getSidebar = ({ dashboardDef, runtimeFlags, featureFlags, isAccessAllowed, language = 'pt-BR', currentPath }: GetSidebarProps): SidebarDef => {
  const routerDef = dashboardDef;

  const routerWithRuntimeFlag = getRoutesWithRuntimeFlag(routerDef, runtimeFlags);
  const routerWithPermission = getRoutesWithPermission(routerWithRuntimeFlag, isAccessAllowed);
  const routerWithFeatureFlag = getRoutesWithFeatureFlag(routerWithPermission, featureFlags);
  const routerWithEnvironment = getRoutesWithEnvironment(routerWithFeatureFlag);
  const routerWithRedirect = getRoutesWithRedirect(routerWithEnvironment);
  const { router, route, primary } = getRouter(routerWithRedirect, currentPath);
  const pagesFlatted = getPagesFlatted(router, undefined, undefined, language);

  const currentPrimary = primary || router[0];
  const currentSecondary = currentPrimary?.routes || undefined;

  const hasSecondary = !!currentSecondary && currentSecondary.length > 0;
  const hasRoute = !!route;

  return {
    router,
    route,
    pagesFlatted,
    primary,
    secondary: currentSecondary,
    hasSecondary,
    hasRoute,
  };
};

export default getSidebar;
